import { useState } from "react";
import { SlidersHorizontal } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { fmtPts } from "../lib/api";
import { AdjustmentDialog } from "./AdjustmentDialog";
import { RemoveMemberButton } from "./RemoveMemberButton";

const MEDAL = ["text-amber-400", "text-slate-300", "text-orange-400"];

export const Leaderboard = ({ t, onChanged }) => {
  const { user } = useAuth();
  const [editing, setEditing] = useState(null);
  return (
    <div className="card-surface overflow-x-auto" data-testid="leaderboard">
      <table className="w-full text-sm">
        <thead>
          <tr className="text-left font-mono text-[10px] uppercase tracking-widest text-slate-400 border-b border-[#26334D]">
            <th className="px-2 sm:px-3 py-1.5">#</th><th className="px-2 sm:px-3 py-1.5">Giocatore</th><th className="px-2 sm:px-3 py-1.5 text-right">Punti</th>
            <th className="hidden sm:table-cell px-3 py-1.5 text-right">Giocate</th><th className="hidden sm:table-cell px-3 py-1.5 text-right">Indovinate</th>
            <th className="px-2 sm:px-3 py-1.5 text-right">Esatti</th><th className="px-2 sm:px-3 py-1.5 text-right">Bonus</th>
            <th className="hidden md:table-cell px-3 py-1.5 text-right">Rettifica</th>
            {t.is_admin && <th className="px-2 sm:px-3 py-1.5" />}
          </tr>
        </thead>
        <tbody>
          {t.leaderboard.map((r) => (
            <tr key={r.user_id} className={`border-b border-[#26334D]/60 last:border-0 ${r.user_id === user?.id ? "bg-emerald-500/5" : ""}`} data-testid={`leaderboard-row-${r.user_id}`}>
              <td className={`px-2 sm:px-3 py-1.5 font-display text-lg font-black ${MEDAL[r.rank - 1] || "text-slate-500"}`}>{r.rank}</td>
              <td className="px-2 sm:px-3 py-1.5 font-semibold max-w-[9rem] sm:max-w-none truncate">{r.name}{r.user_id === user?.id && <span className="ml-1.5 text-xs text-emerald-400">(tu)</span>}</td>
              <td className="px-2 sm:px-3 py-1.5 text-right font-display text-lg font-black text-emerald-400" data-testid={`leaderboard-points-${r.user_id}`}>{fmtPts(r.points)}</td>
              <td className="hidden sm:table-cell px-3 py-1.5 text-right text-slate-300">{r.played}</td>
              <td className="hidden sm:table-cell px-3 py-1.5 text-right text-slate-300">{r.correct}</td>
              <td className="px-2 sm:px-3 py-1.5 text-right text-violet-400">{r.exact}</td>
              <td className="px-2 sm:px-3 py-1.5 text-right text-amber-400">{r.bonuses}</td>
              <td className="hidden md:table-cell px-3 py-1.5 text-right text-slate-400">{r.adjustment ? (r.adjustment > 0 ? "+" : "") + fmtPts(r.adjustment) : "—"}</td>
              {t.is_admin && (
                <td className="px-2 sm:px-3 py-1.5 text-right whitespace-nowrap">
                  <button onClick={() => setEditing(r)} className="text-slate-400 hover:text-amber-400" title="Rettifica punti" data-testid={`adjust-button-${r.user_id}`}>
                    <SlidersHorizontal size={16} />
                  </button>
                  {r.user_id !== user?.id && <RemoveMemberButton tid={t.id} row={r} onRemoved={onChanged} />}
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </table>
      <AdjustmentDialog tid={t.id} row={editing} onClose={() => setEditing(null)} onSaved={onChanged} />
    </div>
  );
};
